import React from "react";
import "./style.css";
import { InlineNotificationInterface } from "./types";

const InlineNotification: React.FC<InlineNotificationInterface> = ({
  kind,
  children,
}) => {
  return (
    <div className={`notification notification-${kind}`}>
      <span className="notification__dot" aria-hidden="true" />
      <span className="notification__text">{children}</span>
    </div>
  );
};

export default InlineNotification;
